document.addEventListener('DOMContentLoaded', () => {
  const isMobile = () => window.matchMedia("(max-width: 480px)").matches;
  (function setVh() {
    const set = () => document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    set();
    window.addEventListener('resize', set);
  })();
  /** -------------------------------
   * Flickity slider
   * ------------------------------- */
  const sliderContainer = document.querySelector('.proofs-video-container');
  let isDragging = false;
  if (sliderContainer) {
    const flkty = new Flickity(sliderContainer, {
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      prevNextButtons: false,
      imagesLoaded: true,
      adaptiveHeight: true,
      pageDots: false,
      autoPlay: isMobile() ? 8000 : false
    });

    flkty.on('dragStart', () => isDragging = true);
    flkty.on('dragEnd', () => setTimeout(() => isDragging = false, 50));

    document.querySelector('.flickity-custom-proofs-prev')?.addEventListener('click', () => flkty.previous());
    document.querySelector('.flickity-custom-proofs-next')?.addEventListener('click', () => flkty.next());
  }

  /** -------------------------------
   * Swiper popup slider
   * ------------------------------- */
  const sliderPopupContainer = document.querySelector('.social-proof-popup-video-container');
  const videoPopupContainer = document.querySelector('.video-play-popup-content');
  const popupContainer = document.querySelector('.video-play-popup-container');
  const popupClose = document.querySelector('.video-sl-popup__close');
  const playBtns = document.querySelectorAll('.js-play-proofs-btn');

  if (!sliderPopupContainer) return;

  const nextEl = sliderPopupContainer.querySelector('.swiper-button-next-custom')
  const prevEl = sliderPopupContainer.querySelector('.swiper-button-prev-custom')

  const popupSwiper = new Swiper(sliderPopupContainer, {
    slidesPerView: 1,
    direction: 'vertical',
    speed: 500,
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl
    }
  });

  const slides = sliderPopupContainer.querySelectorAll('.swiper-slide');
  const soundEnableBtn = videoPopupContainer.querySelector('.video-sl-slider-popup-mute');
  const soundDisableBtn = videoPopupContainer.querySelector('.video-sl-slider-popup-sound');
  let isMuted = false;

  const setGlobalMute = (mute) => {
    slides.forEach(slide => {
      const video = slide.querySelector('video');
      if (video) video.muted = mute;
    });
    isMuted = mute;
  };

  soundDisableBtn.addEventListener('click', () => {
    setGlobalMute(true);
    soundEnableBtn.style.display = "block"
    soundDisableBtn.style.display = "none"
  })
  soundEnableBtn.addEventListener('click', () => {
    setGlobalMute(false);
    soundEnableBtn.style.display = "none"
    soundDisableBtn.style.display = "block"
  })

  // Attach click and progress listeners once
  slides.forEach(slide => {
    const video = slide.querySelector('video');
    const progressBar = slide.querySelector('.video-sl-popup__slide__progress');
    const playBtn = slide.querySelector('.popup-play-btn');

    if (!video) return;

    // Click to play/pause
    video.addEventListener('click', () => {
      if (video.paused) {
        video.play();
        playBtn.style.display = 'none'
      }
      else {
        video.pause();
        playBtn.style.display = 'block'
      }
    });

    playBtn.addEventListener('click', () => {
      if (video.paused) {
        video.play();
        playBtn.style.display = 'none'
      }
    });
    

    // Update progress bar
    video.addEventListener('timeupdate', () => {
      if (progressBar) {
        const percent = (video.currentTime / video.duration) * 100;
        progressBar.style.width = `${percent}%`;
      }
    });
  });

  // Slide change logic
  popupSwiper.on('slideChange', function () {
    slides.forEach((slide, idx) => {
      const video = slide.querySelector('video');
      const progressBar = slide.querySelector('.video-sl-popup__slide__progress');
      const playBtn = slide.querySelector('.popup-play-btn');
      if (!video) return;

      playBtn.style.display = 'none'

      if (idx === this.activeIndex) {
        video.muted = isMuted;
        video.currentTime = 0;
        video.play().catch(err => console.warn('Autoplay blocked:', err));
      } else {
        video.pause();
        if (progressBar) progressBar.style.width = '0%';
      }
    });
  });

  // Play button logic
  playBtns.forEach((btn, index) => {
    btn.addEventListener('click', () => {
      if (isDragging) return;
      popupContainer.classList.add('m-show');
      popupSwiper.slideTo(index, 500);

      const video = slides[index].querySelector('video');
      if (video) video.play().catch(err => console.warn('Autoplay blocked:', err));
    });
  });

  // Close popup
  popupClose?.addEventListener('click', () => {
    popupContainer.classList.remove('m-show');
    slides.forEach(slide => slide.querySelector('video')?.pause());
  });

  const buyVideoBtns = document.querySelectorAll('.buy-now-from-video');
  buyVideoBtns && buyVideoBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const originalAtc = document.querySelector('[data-add-to-cart]')
      originalAtc.click();
      popupClose.click();
    })
  })
});
